import AlertBreakDownBoxes from './AlertBreakDownBoxes'

export default AlertBreakDownBoxes
